const eventBus = require('js-event-bus')();
import domReady from '../utils/domReady';
import Swiper, {
  Navigation,
  Scrollbar,
  Pagination,
  EffectFade,
  Autoplay,
} from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Scrollbar]);
const slider = () => {
  domReady(() => {
    const is_frontpage = document.body.classList.contains('home');
    const is_single = document.body.classList.contains('single-post');
    const defaultSliderOptions = {
      containerModifierClass: 'c-slider__container-',
      sliderClass: 'c-slider__item',
      slideActiveClass: 'is-active',
      slideDuplicateClass: 'c-slider__item--duplicate',
      slideDuplicateActiveClass: 'c-slider__item--duplicate is-active',
      slideDuplicateNextClass: 'c-slider__item--duplicate is-next',
      slideDuplicatePrevClass: 'c-slider__item--duplicate is-prev',
      slideVisibleClass: 'is-visible',
      slideNextClass: 'is-next',
      slidePrevClass: 'is-prev',
      slideBlankClass: 'c-slider__item--invisible-blank',
      wrapperClass: 'c-slider__wrapper',
    }
    if (is_frontpage) {
      const autoplaySpeed = Number(window.theme_data.slider_speed);
      const sliderEl = document.querySelector('.c-slider--posts');

      const heroSlider = new Swiper('.c-slider--posts', {
        direction: 'vertical',
        autoplay: autoplaySpeed ? {
          delay: autoplaySpeed,
        } : false,
        effect: 'fade',
        loop: true,
        pagination: {
          el: '.c-slider__pagination',
          clickable: true,
        },
        threshold: 15,
        on: {
          slideChange: (e) => {
            if (e.slides[e.activeIndex].classList.contains('c-slider__item--rebrand')) {
              eventBus.emit('startLogoAnimation', null, true)
            } else {
              eventBus.emit('startLogoAnimation', null, false)
            }
          },
        },
      })
      heroSlider;
    }
    if (is_single) {
      const sliders = document.querySelectorAll('.c-slider--single');
      if (sliders && sliders.length) {
        let sliderOptions = {
          spaceBetween: 16,
          slidesPerView: 2,
          centeredSlides: true,
          scrollbar: {
            el: '.c-slider__scrollbar',
            dragClass: 'c-slider__scrollbar-drag',
          },
          pagination: {
            el: '.c-slider__pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.c-slider__nav-btn--next',
            prevEl: '.c-slider__nav-btn--prev',
          },
        }
        sliders.forEach((el) => {
          if (el.classList.contains('c-slider--with-content')) {
            sliderOptions.slidesPerView = 1
            sliderOptions.loop = true
            sliderOptions.centeredSlides = false
            sliderOptions.breakpoints = {
              1024: {
                centeredSlides: true,
              },
            }
          } else if (el.classList.contains('c-slider--gallery')) {
            sliderOptions.centeredSlides = true
            sliderOptions.speed = 600
            sliderOptions.breakpoints = {
                320: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 2,
                },
            }
          }
          const slider = new Swiper(el, sliderOptions);
          return slider;
        })
      }
    }
  })
}
slider();
